'use client'

import { Map as MapIcon } from 'lucide-react'
import { motion } from 'motion/react'

export function ContactOffices() {
    const offices = [
        {
            id: "nova-realty-sales-gallery",
            title: "Nova Realty Sales Gallery",
            address: "Nova Tower, Business Bay\nDubai, United Arab Emirates",
            phone: null,
            email: null,
            action: "Get directions"
        },
        {
            id: "pnca-development-office",
            title: "PNCA and Development Office",
            address: "Bukadra - Nad Al Sheba 1,\nNova Hartland II\nDubai",
            phone: null,
            email: null,
            action: "Get directions"
        },
        {
            id: "crm-and-collections-office",
            title: "CRM and Collections Office",
            address: "Nova Sapphire Building,\nGround Floor, Al Khaleej Al Tejari\n2 Street\nBusiness Bay – Dubai",
            phone: "800 NOVA (6682)",
            email: "helpdesk@novarealty.com",
            action: "Get directions"
        },
        {
            id: "nova-global-studio",
            title: "Nova Global Studio",
            address: "92 Park Lane, Mayfair, London,\nW1K 7TA, United Kingdom",
            phone: "+44 20 7099 1000",
            email: null,
            action: "Get directions"
        }
    ]

    return (
        <section className="py-12 bg-white">
            <div className="container px-4 mx-auto">
                <div className="text-center mb-16 space-y-4">
                    <span className="text-xs font-bold tracking-[0.3em] text-secondary uppercase block">
                        Global Presence
                    </span>
                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="font-serif text-4xl md:text-5xl text-primary leading-[0.9]"
                    >
                        Our <span className="italic text-primary/50">Offices</span>
                    </motion.h2>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {offices.map((office, i) => (
                        <motion.div
                            key={office.id}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: i * 0.1 }}
                            className="bg-[#FAFAFA] p-8 md:p-10 rounded-sm hover:shadow-lg transition-shadow duration-300 flex flex-col justify-between min-h-[400px]"
                        >
                            <div>
                                <h3 className="text-2xl font-serif mb-8 leading-tight">{office.title}</h3>
                                <p className="text-muted-foreground text-sm leading-relaxed mb-6 whitespace-pre-line">
                                    {office.address}
                                </p>

                                <div className="space-y-3 text-sm text-muted-foreground">
                                    {office.phone && (
                                        <div className="flex items-center gap-2">
                                            <span className="text-[#C6A87C]">📞</span> {office.phone}
                                        </div>
                                    )}
                                    {office.email && (
                                        <div className="flex items-center gap-2">
                                            <span className="text-[#C6A87C]">✉️</span> {office.email}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <button type="button" className="flex items-center gap-2 text-[#C6A87C] text-sm font-medium hover:underline mt-8 uppercase tracking-widest">
                                <MapIcon className="w-4 h-4" />
                                {office.action}
                            </button>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}
